/* ═══════════════════════════════════════════════════════════
   BRASILHAIR — Build Your Bundle ("Composez votre pack")
   Vanilla JS, defer-safe, guarded. Selects N products then
   adds them all to the cart via /cart/add.js.
═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function money(cents) {
    // Brasilhair is a FR store — EUR with comma decimal.
    var value = (cents / 100).toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return value + ' €';
  }

  function init(root) {
    var bundleSize = parseInt(root.getAttribute('data-bundle-size'), 10) || 3;
    var discountCode = (root.getAttribute('data-discount-code') || '').trim();

    var cards = Array.prototype.slice.call(root.querySelectorAll('.bdl-card'));
    var bar = root.querySelector('.bdl-bar');
    var progressLabel = root.querySelector('[data-bdl-progress]');
    var progressFill = root.querySelector('[data-bdl-fill]');
    var totalVal = root.querySelector('[data-bdl-total]');
    var confirmBtn = root.querySelector('[data-bdl-confirm]');
    var errorEl = root.querySelector('[data-bdl-error]');

    if (!cards.length || !bar || !confirmBtn) return; // guard: nothing to wire up

    // Selected items keyed by variant id -> { id, price }
    var selected = {};

    function selectedCount() {
      return Object.keys(selected).length;
    }

    function selectedTotal() {
      var t = 0;
      Object.keys(selected).forEach(function (id) {
        t += selected[id].price;
      });
      return t;
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.classList.add('is-shown');
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.classList.remove('is-shown');
    }

    function render() {
      var count = selectedCount();
      var reached = count >= bundleSize;

      if (progressLabel) {
        progressLabel.innerHTML =
          '<b>' + count + '</b> / ' + bundleSize + ' sélectionnés';
      }
      if (progressFill) {
        var pct = Math.min(100, Math.round((count / bundleSize) * 100));
        progressFill.style.width = pct + '%';
      }
      if (totalVal) {
        totalVal.textContent = money(selectedTotal());
      }

      confirmBtn.disabled = !reached;
      bar.classList.toggle('is-active', count > 0);
    }

    cards.forEach(function (card) {
      var btn = card.querySelector('.bdl-select');
      if (!btn) return;

      var variantId = card.getAttribute('data-variant-id');
      var price = parseInt(card.getAttribute('data-price'), 10) || 0;
      if (!variantId) {
        btn.disabled = true;
        return;
      }

      btn.addEventListener('click', function () {
        clearError();
        if (selected[variantId]) {
          delete selected[variantId];
          card.classList.remove('is-selected');
        } else {
          if (selectedCount() >= bundleSize) {
            showError(
              'Votre pack est complet (' +
                bundleSize +
                ' articles). Retirez-en un pour en changer.'
            );
            return;
          }
          selected[variantId] = { id: variantId, price: price };
          card.classList.add('is-selected');
        }
        render();
      });
    });

    confirmBtn.addEventListener('click', function () {
      clearError();
      var ids = Object.keys(selected);
      if (ids.length < bundleSize) return;

      confirmBtn.classList.add('is-loading');
      confirmBtn.disabled = true;
      var originalText = confirmBtn.textContent;
      confirmBtn.textContent = 'Ajout en cours…';

      var items = ids.map(function (id) {
        return { id: parseInt(id, 10) || id, quantity: 1 };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error((data && data.description) || 'add_failed');
            });
          }
          return res.json();
        })
        .then(function () {
          // Fire the discount cookie in the background (applies at checkout) — non-blocking
          if (discountCode) { try { fetch('/discount/' + encodeURIComponent(discountCode), { credentials: 'same-origin' }); } catch (e) {} }
          confirmBtn.classList.remove('is-loading');
          confirmBtn.textContent = originalText;
          // Open the cart drawer immediately
          if (typeof window.BrasilOpenCart === 'function') { window.BrasilOpenCart(); }
          else { window.location.href = '/cart'; }
        })
        .catch(function (err) {
          confirmBtn.classList.remove('is-loading');
          confirmBtn.disabled = false;
          confirmBtn.textContent = originalText;
          showError(
            "Une erreur est survenue lors de l'ajout au panier. Veuillez réessayer. (" +
              (err && err.message ? err.message : 'erreur') +
              ')'
          );
        });
    });

    render();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-bundle-root]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
